import { gql, skipToken, useQuery, useSuspenseQuery } from '@apollo/client'
import { getApolloClient } from '../apollo/apolloClientSingleton'
import { getCurrentCachedUser, useCurrentUser } from '../../common/user/currentApolloUser'

const isAppPayments = () => Boolean(window.paymentData)

const GET_CUSTOMER_IMPERSONATION = gql`
  query getCustomerImpersonation {
    getCustomerImpersonation {
      objectId
    }
  }
`

const IMPERSONATE_CUSTOMER = gql`
  mutation impersonateCustomer($customerId: ID!, $reason: String!, $region: String!) {
    impersonateCustomer(customerId: $customerId, reason: $reason, region: $region) {
      objectId
      session {
        sessionToken
      }
    }
  }
`

export const impersonateCustomerMutation = async ({ customerId, reason }) => {
  const client = getApolloClient()
  const { data } = await client.mutate({
    mutation: IMPERSONATE_CUSTOMER,
    variables: {
      customerId,
      reason,
      region: process.env.REGION
    }
  })
  return data.impersonateCustomer
}

export const useIsCustomerImpersonation = () => {
  const user = useCurrentUser()
  const { data, loading } = useQuery(GET_CUSTOMER_IMPERSONATION, { skip: !user || isAppPayments() })
  return {
    isCustomerImpersonation: Boolean(data?.getCustomerImpersonation),
    loading
  }
}

export const useSuspenseIsCustomerImpersonation = () => {
  const user = useCurrentUser()
  const { data } = useSuspenseQuery(
    GET_CUSTOMER_IMPERSONATION,
    user && !isAppPayments() ? { variables: {} } : skipToken
  )
  return Boolean(data?.getCustomerImpersonation)
}

export const getIsCustomerImpersonation = async () => {
  if (isAppPayments()) return false
  const user = getCurrentCachedUser()
  if (!user) return false
  const { data } = await getApolloClient().query({ query: GET_CUSTOMER_IMPERSONATION })
  return Boolean(data?.getCustomerImpersonation)
}
